
import React from "react";
import { motion } from "framer-motion";
import { Users } from "lucide-react";

interface TeamBuilderHeaderProps {
  // No props needed for now
}

export const TeamBuilderHeader: React.FC<TeamBuilderHeaderProps> = () => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="mb-8"
    >
      <h1 className="text-3xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent mb-4">
        Team Builder
      </h1>
      <p className="text-gray-600 max-w-3xl">
        Assemble the perfect team for your complex projects. Browse our network of experts and build a custom team with complementary skills to achieve your project goals.
      </p>
    </motion.div>
  );
};
